EMMY.entrantsLocked = {
  init: function () {
    //EMMY.entrants.clickableListing();
  },
};